export const base_url = "https://backend.gulabidecor.com";
